// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"3ce98a2f","196":"9032744b","304":"1a58651b","843":"66974ae0"}[chunkId] + ".chunk.css";
};